export default {
  my_state_code: [
    {
      "value": "JHR",
      "label": "Johor"
    },
    {
      "value": "KDH",
      "label": "Kedah"
    },
    {
      "value": "KTN",
      "label": "Kelantan"
    },
    {
      "value": "MLK",
      "label": "Melaka"
    },
    {
      "value": "NSN",
      "label": "Negeri Sembilan"
    },
    {
      "value": "PHG",
      "label": "Pahang"
    },
    {
      "value": "PRK",
      "label": "Perak"
    },
    {
      "value": "PLS",
      "label": "Perlis"
    },
    {
      "value": "PNG",
      "label": "Pulau Pinang"
    },
    {
      "value": "SBH",
      "label": "Sabah"
    },
    {
      "value": "SRW",
      "label": "Sarawak"
    },
    {
      "value": "SGR",
      "label": "Selangor"
    },
    {
      "value": "TRG",
      "label": "Terengganu"
    },
    {
      "value": "KUL",
      "label": "Wilayah Persekutuan Kuala Lumpur"
    },
    {
      "value": "LBN",
      "label": "Wilayah Persekutuan Labuan"
    },
    {
      "value": "PJY",
      "label": "Wilayah Persekutuan Putra Jaya"
    }
  ],

  active_countries: [
    {
      "label": "Malaysia",
      "value": "my"
    },
  ],
}

